import { FlexRowAlignCenter } from "@/components/Flex";
import { themeColors } from "@/utils/themeColors";

export const GapPerSection = ({ height = "2rem" }) => {
    return <div style={{ paddingBottom: height }} data-testid="auto-id-96426f13-102c-488c-bb5a-def3acc894c8" />;
};

export const OrDivider = () => {
    return (
        <FlexRowAlignCenter style={{ gap: "2.2rem", width: "100%", maxWidth: "40rem", margin: "0 auto" }}>
            <div
                style={{ flex: 1, border: `1px solid ${themeColors.background}` }}
                data-testid="auto-id-e36716f7-5305-41f6-b38b-393ad8a7bffb"
            />
            <span
                style={{ fontSize: "1.4rem", fontWeight: "600" }}
                data-testid="auto-id-d8f75897-9a5d-4dc8-aaa1-18d85e7a4cbe">
                or
            </span>
            <div
                style={{ flex: 1, border: `1px solid ${themeColors.background}` }}
                data-testid="auto-id-9f37e7a0-8790-4f76-91ee-ab663b9bb93a"
            />
        </FlexRowAlignCenter>
    );
};
